export default __webpack_public_path__ + "static/media/navstep1-1.pic.aca1a401.jpg";